<template>
  <div class="brand-introduction">
    <!-- Hero Banner -->
    <HeroBanner
        :background-image="bannerImage"
        title="브랜드 소개"
        sub-title="전문성을 바탕으로 한 최고의 보청기전문기업, <br>다비치 히어링 보청기입니다."
    />

    <!-- Main Content -->
    <div class="brand-content">
      <!-- Reliability Section -->
      <section class="brand-section reliability-section" :style="reliabilityBgStyle">
        <div class="section-content">
          <div class="section-header">
            <h2 class="section-title-en">Reliability</h2>
            <h3 class="section-title-kr">신뢰할 수 있는 브랜드</h3>
          </div>
          <div class="section-texts">
            <p class="section-text">
              보이지 않았지만 우리는 항상 지켜왔습니다. <br>
              언제나 고객이 필요할 때 있어야 할 곳에서 묵묵히 해야 할 일을<br>
               했습니다. 신뢰는 보이지 않는 작은 곳에서부터 시작되는 <br>
              것을 우리는 잘 알고 있기 때문입니다.
            </p>
            <p class="section-text">
              보이지 않는 곳에서 손을 내밀어 도움을 주는 여러분이 믿고 <br>
              의지 할 수 있는 우리는 다비치입니다.
            </p>
          </div>
          <div class="section-divider"></div>
        </div>
      </section>

      <!-- Empathy Section -->
      <section class="brand-section empathy-section" :style="empathyBgStyle">
        <div class="section-content">
          <div class="section-header">
            <h2 class="section-title-en dark">Empathy</h2>
            <h3 class="section-title-kr dark">함께 공감하는 브랜드</h3>
          </div>
          <div class="section-texts">
            <p class="section-text dark">
              세상을 보는 관점을 바꾸는 것은 매우 어려운 일이었습니다.
            </p>
            <p class="section-text dark">
              노력은 항상 어려운 일에 필요합니다. <br>
              고객의 시선으로 세상을 이해하는 것은 말로는 쉽게 할 수 <br>
              있습니다. 그 일이 어려운 일인 것을 알고 있기에 우리는 <br>
              노력하고 있습니다. <br>
              마음으로부터 다가가기 위해 노력하고 있습니다. <br>
              진실된 경험을 전달하기 위해 노력하고 있습니다. <br>
              당신과 같은 곳을 바라보는 우리는 다비치입니다.
            </p>
          </div>
          <div class="section-divider dark"></div>
        </div>
      </section>

      <!-- Attunement Section -->
      <section class="brand-section attunement-section" :style="attunementBgStyle">
        <div class="section-content">
          <div class="section-header">
            <h2 class="section-title-en dark">Attunement</h2>
            <h3 class="section-title-kr dark">항상 조율하는 브랜드</h3>
          </div>
          <div class="section-texts">
            <p class="section-text dark">
              하루가 다르게 세상은 빠르게 변하고 있습니다. <br>
              우리를 불안하게 하는 많은 것들이 나타났다 사라지는 일을 <br>
              반복합니다. 불안한 많은 일들을 마주했을 때 균형을 잡으면<br>
              한쪽으로 치우치지 않습니다. 기술이 발전하고 시대가 <br>
              바뀌어도 변하지 말아야 할 것들이 있습니다.
            </p>
            <p class="section-text dark">
              복잡한 세상의 중심에서 당신을 위해 균형을 잡고 있겠습니다. 당신과 함께하는 우리는 다비치입니다.
            </p>
          </div>
          <div class="section-divider dark"></div>
        </div>
      </section>

      <!-- Davichi Values Section -->
<!--      <section class="values-section">-->
<!--        <div class="values-circles">-->
<!--          <div class="value-circle">-->
<!--            <div class="circle-border">-->
<!--              <div class="circle-content">-->
<!--                <strong class="value-title">Reliability</strong>-->
<!--                <span class="value-subtitle">신뢰할 수 있는</span>-->
<!--              </div>-->
<!--              <div class="value-label">머리(의식)</div>-->
<!--            </div>-->
<!--          </div>-->

<!--          <div class="value-circle offset">-->
<!--            <div class="circle-border">-->
<!--              <div class="circle-content">-->
<!--                <strong class="value-title">Empathy</strong>-->
<!--                <span class="value-subtitle">함께 공감하는</span>-->
<!--              </div>-->
<!--              <div class="value-label">가슴(마음)</div>-->
<!--            </div>-->
<!--          </div>-->

<!--          <div class="value-circle">-->
<!--            <div class="circle-border">-->
<!--              <div class="circle-content">-->
<!--                <strong class="value-title">Attunement</strong>-->
<!--                <span class="value-subtitle">항상 조율하는</span>-->
<!--              </div>-->
<!--              <div class="value-label">손(표현)</div>-->
<!--            </div>-->
<!--          </div>-->

<!--          <div class="arrow-down">-->
<!--            <svg width="23" height="56" viewBox="0 0 23 56" fill="none">-->
<!--              <path d="M10.2322 55.2678C10.8179 55.8536 11.7679 55.8536 12.3536 55.2678L21.8995 45.7219C22.4853 45.1362 22.4853 44.1862 21.8995 43.6005C21.3137 43.0147 20.3638 43.0147 19.778 43.6005L11.2929 52.0855L2.80785 43.6005C2.22207 43.0147 1.27213 43.0147 0.686354 43.6005C0.100574 44.1862 0.100574 45.1362 0.686354 45.7219L10.2322 55.2678ZM9.79285 0L9.79285 54.2072H12.7929L12.7929 0L9.79285 0Z" fill="#222222"/>-->
<!--            </svg>-->
<!--          </div>-->

<!--          <div class="davichi-circle">-->
<!--            <div class="davichi-badge">다비치다움</div>-->
<!--          </div>-->
<!--        </div>-->

<!--        <div class="values-description">-->
<!--          <p class="description-text">-->
<!--            다비치다움이란 다비치의 기본 원칙입니다. 이것은 모두에게 변하지 않는 신뢰를 만들어가는 과정이며, 이를 묵묵히 지켜가고자 하는 정신입니다.-->
<!--          </p>-->
<!--          <p class="description-text">-->
<!--            우리만의 전문성을 바탕으로 한 고객 응대 프로세스를 만들어 왔으며, 전국 공통의 보편적 서비스로 추구하기 위해 우리의 모든 경험을 체계화 하기위한 노력을 지속하고 있습니다.-->
<!--          </p>-->
<!--          <p class="description-text">-->
<!--            우리의 노력은 궁극적으로 고객을 향한 봉사 정신과 활동이며, 이러한 묵묵한 발걸음을 통해 고객에게 감동을 드릴 수 있다는 사명감을 최선을 다해 지켜가고 있습니다.-->
<!--          </p>-->
<!--        </div>-->
<!--      </section>-->
      <section class="values-section">
        <div class="history-image">
          <img class="responsive-img" src="@/assets/images/banners/02_content_04@2x.png" width="500" alt="다비치 히어링 가치 소개" />
        </div>
          <div class="values-description">
            <p class="description-text">
              다비치다움이란 다비치의 기본 원칙입니다. <br>
              이것은 모두에게 변하지 않는 신뢰를 만들어가는 과정이며, <br>
              이를 묵묵히 지켜가고자 하는 정신입니다.
            </p>
            <p class="description-text">
              우리만의 전문성을 바탕으로 한 <br>
              고객 응대 프로세스를 만들어 왔으며, <br>
              전국 공통의 보편적 서비스로 추구하기 위해 <br>
              우리의 모든 경험을 체계화 하기위한 노력을 <br>
              지속하고 있습니다.
            </p>
            <p class="description-text">
              우리의 노력은 궁극적으로 고객을 향한 봉사 정신과 활동이며,<br>
              이러한 묵묵한 발걸음을 통해 고객에게 감동을 드릴 수 <br>
              있다는 사명감을 최선을 다해 지켜가고 있습니다.
            </p>
          </div>
      </section>
      <section class="history-section">
        <div class="history-image">
          <img src="@/assets/images/banners/02_content_05@2x.png" alt="다비치 히어링 본사" />
        </div>

        <!-- 로딩/에러/빈 데이터 상태 -->
        <DataStateMessage
          v-if="historiesLoading"
          state="loading"
          loading-message="연혁 정보를 불러오는 중..."
        />
        <DataStateMessage
          v-else-if="historiesError"
          state="error"
          :error-message="historiesError"
          @retry="loadHistories"
        />
        <DataStateMessage
          v-else-if="histories.length === 0"
          state="empty"
          empty-message="등록된 연혁이 없습니다."
        />

        <!-- 연혁 타임라인 -->
        <div v-else class="history-timeline">
          <div
            v-for="history in sortedHistories"
            :key="history.id"
            class="timeline-item"
          >
            <div class="timeline-year">{{ history.yyyy }}</div>
            <div class="timeline-events" v-html="history.description"></div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import HeroBanner from "@/components/HeroBanner.vue";
import DataStateMessage from "@/components/DataStateMessage.vue";
import { fetchHistory } from "@/api";
import bannerBg from '@/assets/images/heros/01-top-img.png';
import content01Bg from '@/assets/images/banners/02_content_01.png';
import content02Bg from '@/assets/images/banners/02_content_02.png';
import content02Bg2x from '@/assets/images/banners/02_content_02@2x.png';
import content03Bg from '@/assets/images/banners/02_content_03.png';

export default {
  name: 'BrandIntroduction',
  components: {
    HeroBanner,
    DataStateMessage
  },
  data() {
    return {
      bannerImage: [bannerBg],
      histories: [],
      historiesLoading: false,
      historiesError: null
    };
  },
  async created() {
    await this.loadHistories();
  },
  computed: {
    reliabilityBgStyle() {
      return {
        backgroundImage: `url(${content01Bg})`,
      };
    },
    empathyBgStyle() {
      // Retina 이미지 지원
      const dpr = window.devicePixelRatio || 1;
      if (dpr >= 2) {
        return {
          backgroundImage: `url(${content02Bg2x})`,
        };
      }
      return {
        backgroundImage: `url(${content02Bg})`,
      };
    },
    attunementBgStyle() {
      return {
        backgroundImage: `url(${content03Bg})`,
      };
    },
    /**
     * 연도 기준 내림차순 정렬된 연혁 데이터
     */
    sortedHistories() {
      if (!this.histories || this.histories.length === 0) {
        return [];
      }
      return this.histories.filter(ele => ele.disp_yn === 'Y');
    }
  },
  methods: {
    /**
     * 회사 연혁 데이터 조회
     * - 전체 연혁을 API에서 가져옴 (페이징 없음)
     * - 에러 발생 시 콘솔 로그 및 에러 메시지 저장
     */
    async loadHistories() {
      if (this.historiesLoading) return;

      this.historiesLoading = true;
      this.historiesError = null;

      try {
        // 파라미터 없이 호출하여 전체 조회
        const response = await fetchHistory();
        this.histories = response.data || [];

        if (this.histories.length === 0) {
          console.warn('연혁 데이터가 없습니다.');
        }

      } catch (error) {
        this.historiesError = '연혁 정보를 불러오는 중 오류가 발생했습니다.';
        console.error('===== 연혁 API 호출 에러 =====');
        console.error('에러:', error);
        console.error('에러 상세:', error.response?.data || error.message);
        console.error('============================');
      } finally {
        this.historiesLoading = false;
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/assets/scss/helpers/richText";

.responsive-img {
  max-width: 100%;
  width: 100%;
  height: auto;
  display: block;
}

.brand-introduction {
  width: 100%;
  background: #FFFFFF;

  .brand-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 500px;
    margin: 0 auto;

    // Brand Sections (Reliability, Empathy, Attunement)
    .brand-section {
      width: 100%;
      min-height: 1034.6px;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;

      .section-content {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding: 0 0 122.768px;
        gap: 33.48px;
        width: 350.32px;
        max-width: 90%;
        position: relative;

        .section-header {
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 100%;
          gap: 0;

          .section-title-en {
            font-family: 'Public Sans', sans-serif;
            font-weight: 600;
            font-size: 40px;
            line-height: 47px;
            text-align: center;
            letter-spacing: -2.00893px;
            color: #FFFFFF;
            margin: 0;

            &.dark {
              color: #222222;
            }
          }

          .section-title-kr {
            font-family: 'Noto Sans KR', sans-serif;
            font-weight: 600;
            font-size: 20px;
            line-height: 45px;
            text-align: center;
            letter-spacing: -0.837054px;
            color: #FFFFFF;
            margin: 0;

            &.dark {
              color: #222222;
            }
          }
        }

        .section-texts {
          display: flex;
          flex-direction: column;
          gap: 22.32px;
          width: 100%;

          .section-text {
            font-weight: 300;
            font-size: 15px;
            line-height: 30px;
            text-align: center;
            letter-spacing: -0.6px;
            color: #FFFFFF;
            margin: 0;

            &.dark {
              color: #222222;
            }
          }
        }

        .section-divider {
          position: absolute;
          width: 2.23px;
          height: 33.48px;
          left: calc(50% - 2.23px/2);
          top: -55.8px;
          background: #FFFFFF;
          opacity: 0.3;

          &.dark {
            background: #222222;
          }
        }
      }

      &.reliability-section {
        padding: 125px 0 459.821px;
      }

      &.empathy-section {
        padding: 150.67px 0 373.884px;

        .section-content {
          width: 346.72px;
        }
      }

      &.attunement-section {
        padding: 221.54px 0 333.147px;

        .section-content {
          width: 346.72px;
        }
      }
    }

    // Values Section
    .values-section {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      padding: 133.929px 0 122.768px;
      gap: 78.12px;

      .values-circles {
        width: 100%;
        position: relative;
        height: 1074.22px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .value-circle {
          position: absolute;
          width: 276.79px;
          height: 276.79px;
          left: calc(50% - 276.79px/2);

          &:nth-child(1) {
            top: -33.48px;
          }

          &:nth-child(2) {
            top: 209.82px;
            left: calc(50% - 276.79px/2 + 111.61px);
          }

          &:nth-child(3) {
            top: 453.12px;
            left: calc(50% - 276.79px/2);
          }

          .circle-border {
            width: 100%;
            height: 100%;
            border: 2px solid #E0E0E0;
            border-radius: 50%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            position: relative;

            .circle-content {
              display: flex;
              flex-direction: column;
              align-items: center;
              gap: 11.7188px;

              .value-title {
                font-family: 'Noto Sans KR', sans-serif;
                font-weight: 700;
                font-size: 26px;
                line-height: 31px;
                text-align: center;
                letter-spacing: -1.17188px;
                color: #222222;
              }

              .value-subtitle {
                font-family: 'Noto Sans KR', sans-serif;
                font-weight: 350;
                font-size: 18px;
                line-height: 10px;
                text-align: center;
                letter-spacing: -0.602679px;
                color: #222222;
              }
            }

            .value-label {
              position: absolute;
              bottom: 65.48px;
              font-family: 'Noto Sans KR', sans-serif;
              font-weight: 350;
              font-size: 16px;
              line-height: 32px;
              text-align: center;
              letter-spacing: -0.602679px;
              color: #CCCCCC;
            }
          }
        }

        .arrow-down {
          position: absolute;
          width: 22.32px;
          height: 55.8px;
          left: calc(50% - 22.32px/2);
          top: 729.91px;
        }

        .davichi-circle {
          position: absolute;
          width: 276.79px;
          height: 276.79px;
          left: calc(50% - 276.79px/2);
          top: 785.71px;

          .davichi-badge {
            width: 100%;
            height: 100%;
            background: linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), #0056AA;
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            font-family: 'Noto Sans KR', sans-serif;
            font-weight: 700;
            font-size: 28px;
            line-height: 28px;
            text-align: center;
            letter-spacing: -0.02em;
            color: #FFFFFF;
          }
        }
      }

      .values-description {
        display: flex;
        flex-direction: column;
        gap: 22.32px;
        width: 100%;
        max-width: 500px;
        padding: 0 36px;

        .description-text {
          font-family: 'Noto Sans KR', sans-serif;
          font-weight: 300;
          font-size: 15px;
          line-height: 30px;
          text-align: center;
          letter-spacing: -0.602679px;
          color: #222222;
          margin: 0;
        }
      }
    }

    // History Section
    .history-section {
      width: 100%;
      display: flex;
      flex-direction: column;
      gap: 1.12px;

      .history-image {
        width: 100%;
        height: 558.04px;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      // 로딩, 에러, 빈 데이터 상태 스타일
      .history-loading,
      .history-error,
      .history-empty {
        padding: 80px 36px;
        text-align: center;
        width: 100%;
        max-width: 500px;
        margin: 0 auto;

        p {
          font-family: 'Noto Sans KR', sans-serif;
          font-weight: 350;
          font-size: 16px;
          line-height: 28px;
          color: #666666;
          margin: 0;
        }
      }

      .history-loading {
        p {
          color: #0056AA;
        }
      }

      .history-error {
        p {
          color: #d32f2f;
          margin-bottom: 20px;
        }

        .retry-button {
          padding: 12px 32px;
          font-family: 'Noto Sans KR', sans-serif;
          font-weight: 500;
          font-size: 15px;
          color: #FFFFFF;
          background-color: #0056AA;
          border: none;
          border-radius: 4px;
          cursor: pointer;
          transition: background-color 0.3s;

          &:hover {
            background-color: #003d7a;
          }

          &:active {
            background-color: #002952;
          }
        }
      }

      .history-timeline {
        display: flex;
        flex-direction: column;
        padding: 55px 36px 0;
        gap: 0;
        width: 100%;
        max-width: 500px;
        margin: 0 auto;

        .timeline-item {
          display: flex;
          padding: 20px 0;
          gap: 42px;

          .timeline-year {
            min-width: 42px;
            font-family: 'Public Sans', sans-serif;
            font-weight: 600;
            font-size: 18px;
            line-height: 39px;
            color: #222222;
          }

          .timeline-events {
            @include rich-text-format; // 연혁 설명(v-html) bold/italic/list 서식 복구
            display: flex;
            flex-direction: column;
            flex: 1;
            line-height: 38px;
            font-weight: 300;
            // v-html로 렌더링되는 <p> 태그 스타일
            :deep(p) {
              font-family: 'Noto Sans KR', sans-serif;
              font-weight: 350;
              font-size: 18px;
              line-height: 39px;
              color: #222222;
              margin: 0;
            }
          }
        }
      }
    }


  }

  // Responsive Design
  @media (max-width: 768px) {
    .brand-content {
      .brand-section {
        min-height: 800px;
        padding: 80px 0 300px !important;

        .section-content {
          width: 90%;
          padding: 0 0 80px;
          gap: 28px;

          .section-header {
            .section-title-en {
              font-size: 32px;
              line-height: 38px;
            }

            .section-title-kr {
              font-size: 18px;
              line-height: 36px;
            }
          }

          .section-texts {
            gap: 18px;

            .section-text {
              font-size: 14px;
              line-height: 26px;
            }
          }
        }
      }

      .values-section {
        padding: 80px 0 80px;
        gap: 60px;

        .values-circles {
          height: 900px;
          transform: scale(0.85);
        }

        .values-description {
          padding: 0 20px;

          .description-text {
            font-size: 14px;
            line-height: 26px;
          }
        }
      }

      .history-section {
        .history-image {
          height: 400px;
        }

        .history-timeline {
          padding: 40px 20px 0;

          .timeline-item {
            gap: 20px;

            .timeline-year {
              min-width: 36px;
              font-size: 15px;
              line-height: 32px;
            }

            .timeline-events {
              .timeline-event {
                font-size: 15px;
                line-height: 32px;
              }
            }
          }
        }
      }
    }
  }

  @media (max-width: 450px) {
    .brand-content {
      .brand-section {
        min-height: 700px;
        padding: 60px 0 200px !important;

        .section-content {
          padding: 0 0 60px;
          gap: 24px;

          .section-header {
            .section-title-en {
              font-size: 28px;
              line-height: 34px;
            }

            .section-title-kr {
              font-size: 16px;
              line-height: 32px;
            }
          }

          .section-texts {
            gap: 16px;

            .section-text {
              font-size: 13px;
              line-height: 24px;
            }
          }
        }
      }

      .values-section {
        padding: 60px 0 60px;
        gap: 40px;

        .values-circles {
          height: 800px;
          transform: scale(0.7);
        }

        .values-description {
          padding: 0 15px;

          .description-text {
            font-size: 13px;
            line-height: 24px;
          }
        }
      }

      .history-section {
        .history-image {
          height: 300px;
        }

        .history-timeline {
          padding: 30px 15px 0;

          .timeline-item {
            gap: 15px;
            padding: 15px 0;

            .timeline-year {
              min-width: 32px;
              font-size: 14px;
              line-height: 28px;
            }

            .timeline-events {
              .timeline-event {
                font-size: 14px;
                line-height: 28px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
